/**
 * Trusted Partners Carousel
 * Uses shared scroll-carousel with section-specific selectors.
 */

import { initScrollCarousels } from '../scroll-carousel';

const CONFIG = {
    containerSelector: '[data-module="trusted-partners-carousel"]',
    trackSelector: '.trusted-partners-logos-container',
    dotsContainerSelector: '.trusted-partners-pagination',
    dotClassName: 'trusted-partners-dot',
    hidePaginationWhenSinglePage: true,
    centerWhenNoScroll: true,
};

export default function init() {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => initScrollCarousels(CONFIG));
    } else {
        initScrollCarousels(CONFIG);
    }
}
